import { CircularProgress, Typography } from "@material-ui/core";
import { Fragment, PropsWithChildren } from "react";

export interface LoadWrapperProps extends PropsWithChildren<{}> {
  loading: boolean;
  error?: Error;
}

export function LoadWrapper(props: LoadWrapperProps) {
  const { loading, error, children } = props;

  return (
    <Fragment>
      {loading && <CircularProgress />}
      {!loading && !error && children}
      {error && (
        <Typography variant="body2">
          Si è verificato un errore: {error.message}
        </Typography>
      )}
    </Fragment>
  );
}
